module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ded"
    }
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "page81"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Contents#deda"
    }
  }, [_c('em', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For my mum,"), _c('br'), _vm._v("the most important woman in my life,"), _c('br'), _vm._v("this book is dedicated to you."), _c('br'), _vm._v("Now for God’s sake don’t read it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47f8b9a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062378576_B1_Dedication.vue
// module id = 69
// module chunks = 0